import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PageVersionService {
  private pageVersionSource = new BehaviorSubject<any>({});

  pageVersion = this.pageVersionSource.asObservable();

  constructor() {}

  addPageVersionData(pageVersion: any) {
    this.pageVersionSource.next(pageVersion);
  }
}
